export default __webpack_public_path__ + "static/media/a10.14c07156.png";